<template>
  <v-row >
    <v-dialog
      v-model="dialog"
      persistent
      max-width="800px"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          color="primary"
          dark
          v-bind="attrs"
          v-on="on"
          data-cy="add-categoria-input"
        >
          Agregar Categoria
        </v-btn>
      </template>


      <v-card>
        <v-card-title class="text-h5">
          Seleccionar Categoria
        </v-card-title>
        
<v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-text-field
            v-model="buscador" 
            placeholder="Ejemplo: Facultad de Ciencias y Tecnología"
            outlined
           
          >
          <template v-slot:label>
          <v-icon style="vertical-align: middle">
            mdi-magnify
          </v-icon>
          Busqueda
        </template>
          
          
          </v-text-field>
               <v-simple-table fixed-header>
    <template v-slot:default> 
 <thead>
        <tr>
          <th scope="col">#</th>
          <th scope="col">Descripción</th>
            <th>Seleccionar</th> 

   
    
        </tr>
      </thead>
      <tbody>
        <tr v-for="categoria in categoriasBuscados" :key="categoria.id">
          <th scope="row">{{categoria.id}}</th>
          <td v-on:click="guardarCategoria(categoria)">{{categoria.descripcion}}</td>
            <td><button v-on:click="guardarCategoria(categoria)" class="btn">
              <v-icon left color="green darken-2"
              >mdi-checkbox-marked-circle</v-icon></button></td>

            
        </tr>
      </tbody>
      </template>
  </v-simple-table>
              </v-col>
              
            </v-row>
          </v-container>
        </v-card-text>


    <!--    <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="green darken-1"
            text
            @click="dialog = false"
          >
            Disagree
          </v-btn>
          <v-btn
            color="green darken-1"
            text
            @click="dialog = false"
          >
            Agree
          </v-btn>
        </v-card-actions> -->
      </v-card>
    </v-dialog>
  </v-row>
</template>




<script>

import categoriaService from "@/services/tienda/categoriaService";

 
export default {
  data: () => ({
  
    dialog:false,
    errors: "",
    showError: false,
    categorias: [],
    buscador:'',
    categoria: {
      id: "",
      descripcion: "",
    }
  }),
  mounted() {
    this.listar();
     
  },
  methods: {
    listar() {
      categoriaService
        .listarCategorias()
        .then((resposta) => {
          console.log(resposta.data);
          this.categorias = resposta.data;
         
        })
        .catch((e) => {
          this.errors = e.response.data.errors;
        });
    }, guardarCategoria:function(categoria){

      console.log(categoria);

      let cat={...categoria}

            this.$emit('guardarCategoria',cat);
            this.dialog=false;
        },
  },
  computed:{
    categoriasBuscados() {
      return this.categorias.filter(categoria => {
        return categoria.descripcion.toLowerCase().includes(this.buscador.toLowerCase());
      });

  }
  },




}
    
  
</script>